import { GatePrimaryButton } from './gateUi'
import type { LoginFlow } from './useLoginFlow'

export function CredentialsStage({ flow }: { flow: LoginFlow }) {
  const { email, setEmail, password, setPassword, busy } = flow
  return (
    <form onSubmit={flow.onCredentials} className="login-form">
      <label className="login-field">
        <span>E-mail</span>
        <input
          type="email"
          required
          autoFocus
          placeholder="seu@email.com"
          data-testid="login-email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </label>
      <label className="login-field">
        <span>Senha</span>
        <input
          type="password"
          required
          placeholder="••••••••"
          data-testid="login-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </label>
      <button
        type="submit"
        disabled={busy}
        data-testid="login-submit"
        className="login-button login-button--primary"
      >
        {busy && <span className="login-spinner" aria-hidden="true" />}
        <span>{busy ? 'Entrando…' : 'Entrar'}</span>
      </button>
      <button
        type="button"
        className="login-link-button"
        onClick={flow.startReset}
      >
        Esqueci minha senha
      </button>
    </form>
  )
}

export function MfaStage({ flow }: { flow: LoginFlow }) {
  const { t, mfaCode, setMfaCode, secondsLeft, busy } = flow
  return (
    <form onSubmit={flow.onMfa} data-testid="login-mfa-form" className="login-form">
      <p className="login-card__body login-card__body--center">
        {t('login.mfa.hint', {
          defaultValue:
            'Informe o código TOTP do seu app autenticador ou um código de backup.',
        })}
      </p>
      <label className="login-field">
        <span>Código</span>
        <input
          inputMode="text"
          autoComplete="one-time-code"
          required
          placeholder="000000"
          value={mfaCode}
          data-testid="login-mfa-code"
          onChange={(e) => setMfaCode(e.target.value)}
          className="login-mfa-input"
        />
      </label>
      <p
        data-testid="login-mfa-countdown"
        role="timer"
        className={secondsLeft > 0 ? 'login-timer' : 'login-timer login-timer--expired'}
      >
        {secondsLeft > 0
          ? t('login.mfa.expiresIn', {
              defaultValue: 'Expira em {{mm}}:{{ss}}',
              mm: String(Math.floor(secondsLeft / 60)).padStart(2, '0'),
              ss: String(secondsLeft % 60).padStart(2, '0'),
            })
          : t('login.mfa.expired', {
              defaultValue: 'O desafio expirou. Refaça o login.',
            })}
      </p>
      <GatePrimaryButton
        busy={busy}
        disabled={secondsLeft <= 0}
        testId="login-mfa-submit"
      >
        {busy
          ? t('login.mfa.submitting', { defaultValue: 'Verificando...' })
          : t('login.mfa.submit', { defaultValue: 'Verificar' })}
      </GatePrimaryButton>
      <button
        type="button"
        className="login-link-button"
        onClick={flow.leaveMfa}
      >
        {t('login.mfa.back', { defaultValue: 'Voltar' })}
      </button>
    </form>
  )
}

export function ResetStage({ flow }: { flow: LoginFlow }) {
  const { email, setEmail, busy } = flow
  return (
    <form onSubmit={flow.onReset} className="login-form">
      <label className="login-field">
        <span>Seu e-mail</span>
        <input
          type="email"
          required
          placeholder="seu@email.com"
          data-testid="login-reset-email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </label>
      <GatePrimaryButton busy={busy}>
        {busy ? 'Enviando…' : 'Enviar link'}
      </GatePrimaryButton>
      <button
        type="button"
        className="login-link-button"
        onClick={flow.leaveReset}
      >
        Voltar
      </button>
    </form>
  )
}
